module.exports = __webpack_public_path__ + "static/media/yipaifafenhong@2x.5f5be47e.png";